module.exports = __webpack_public_path__ + "static/img/white_texture.ff0cc98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/textures/white_texture.png
// module id = 444
// module chunks = 1